var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":"","tile":""}},[_c('v-card',[_c('div',{staticClass:"scrollmenu"},[_c('iframe',{staticStyle:{"border":"0"},attrs:{"width":"1300","height":"600","src":_vm.report_url,"frameborder":"0","allowfullscreen":""}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }